import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  menu: {
    padding: '0'
  },

  root: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '0.5rem',
    cursor: 'pointer',
    userSelect: 'none',

    '& .icon': {
      marginRight: '0.25rem',
      fontSize: theme.size.sm,
      color: theme.palette.primary.main,

      '& svg': {
        display: 'block'
      }
    },

    '& .text': {
      fontSize: theme.size.sm,
      color: theme.palette.textLight
    }
  }
}))

export default useStyles
